import { AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import Divider from 'components/divider';
import Tooltip from 'components/tooltip';
import { ChevronDown, Info } from 'lucide-react';
import React from 'react';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { useInputSettingsState } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/context/input-settings-context';
import { ConsumptionAdjustmentMethod } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/consumption-adjustment-method.enum';
import { Accordion, AccordionGroup } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/utils/styled-components';

type Props = {};

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.inputSettings.dailyConsumptionRateTab';

const DailyConsumptionRate: React.FC<Props> = () => {
  const intl = useIntl();
  const {
    getOfdSettingsQuery: { data: ofdSettings },
  } = useInputSettingsState();

  return (
    <>
      <AccordionGroup>
        <Accordion>
          <AccordionSummary
            sx={{ alignItems: 'start' }}
            aria-controls="panel1-content"
            id="panel1-header"
            expandIcon={<ChevronDown />}>
            <Box display={'flex'} flexDirection={'column'} gap={4}>
              <Box display={'flex'} alignItems={'center'} gap={2}>
                <Box display={'flex'} gap={2} alignItems={'center'}>
                  <Typography variant="h2" fontWeight={800}>
                    <FormattedNumber
                      value={ofdSettings?.currentConsumptionRate ?? 0}
                      unit={'kilogram'}
                      style="unit"
                      minimumFractionDigits={0}
                      maximumFractionDigits={0}
                    />
                  </Typography>
                  <FormattedMessage id={`${PAGE_NAME_ID}.day`} />
                </Box>
                <Tooltip title={intl.formatMessage({ id: `${PAGE_NAME_ID}.tooltipMethod` })}>
                  <Box display={'flex'} justifyContent={'center'} alignItems="center">
                    <Info size={18} />
                  </Box>
                </Tooltip>
              </Box>

              <Box>
                <Typography>
                  <FormattedMessage id={`${PAGE_NAME_ID}.calculationMethod`} />
                  <FormattedMessage
                    id={
                      ofdSettings?.consumptionRateAdjustmentMethod === ConsumptionAdjustmentMethod.historicalAverage
                        ? `${PAGE_NAME_ID}.recommended`
                        : `${PAGE_NAME_ID}.manual`
                    }
                  />
                </Typography>
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
            }}>
            <Divider dark />
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gap={2}>
              <Typography>
                <FormattedMessage id={`${PAGE_NAME_ID}.prognosis`} />
                :&nbsp;
                <FormattedNumber
                  value={Number(ofdSettings?.originalConsumptionRate)}
                  unit={'kilogram'}
                  style="unit"
                  minimumFractionDigits={0}
                  maximumFractionDigits={0}
                />
                <FormattedMessage id={`${PAGE_NAME_ID}.day`} />
              </Typography>
              <Tooltip title={intl.formatMessage({ id: `${PAGE_NAME_ID}.tooltipPrognosis` })}>
                <Box component="span" display="flex" justifyContent="center">
                  <Info size={18} />
                </Box>
              </Tooltip>
            </Box>
            {ofdSettings?.consumptionRateAdjustmentMethod === ConsumptionAdjustmentMethod.historicalAverage ? (
              <Box display={'flex'} gap={1}>
                <Typography>{intl.formatMessage({ id: `${PAGE_NAME_ID}.daysHistoricalAverage` })}</Typography>
                {ofdSettings?.consumptionRateAdjustmentDays}
              </Box>
            ) : null}
          </AccordionDetails>
        </Accordion>
      </AccordionGroup>
    </>
  );
};

export default DailyConsumptionRate;
